import React from 'react';
import { connect } from 'react-redux';
import { List, Map, Set } from 'immutable';
import { compose, contains } from 'ramda';

import styleFile from './SearchOptions.js';
import { RichText, Button } from '@synergycms_core/components/generic/';
import SearchOptionCurrency from '../SearchOptionCurrency';
import { SearchOptionFilter } from '../SearchOptionFilter';
import SearchOptionOrderBy from '../SearchOptionOrderBy';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import actions from '../../../store/actions';
import { filterAvailServices } from '../../../store/avail/availServicesActions';
import { getOrderByOptionName } from '../SearchOptionOrderBy/utils';
import ButtonCalendar from '../Calendar/ButtonCalendar';
import HotelInfoButton from '../HotelInfoButton/HotelInfoButton.jsx';
import { reduceWhileResolved, checkAvailSegments } from '../../../utils';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider';
import DestinationAvailBtn from '../DestinationAvailBtn';
import moment from 'moment';

const {
  params: paramsActions,
  step: stepActions,
  currentHotel: currentHotelActions,
  currentHotels: currentHotelsActions,
  orderBy: orderByActions
} = actions.customer;

const { avail: availActions, events: eventsActions } = actions;
const { hotels: hotelsActions } = actions;
const availServicesActions = actions.availServices;
const { filters: filterActions,loyalty:loyaltyActions } = actions.customer;

const OrderByBtn = props => (
  <Button
    onClick={props.toggleSelected}
    innerStyle={
      props.showOrderBy ? [props.classes.searchOptionsButton, 'selected'] : [props.classes.searchOptionsButton]
    }
    richText={{
      translate: true,
      ucFirst: true,
      text: getOrderByOptionName(props.currentOrderBy).toLowerCase(),
      innerStyle: ['capitalize', props.classes.searchOptionsButtonText],
      icon: {
        content: '', //invisible icon
        innerStyle: [props.classes.searchOptionsButtonIcon, props.classes.white]
      },

      rightIcon: {
        unicodeContent: 'e052',
        innerStyle: [props.classes.searchOptionsButtonIconOpen]
      }
    }}
  />
);

const BackBtnSegments = props =>
  props.totalSegments > 1 &&
  props.currentStep === 'monoHotelAvail' && (
    <span>
      {' '}
      <RichText text={(props.activeSegment || 1) + '/' + props.totalSegments} />
    </span>
  );

const BackBtn = props => {
  //console.log(props.activeSegment);
  return (
    <div
      className={
        props.currentStep === 'serviceHotelAvail'
          ? [props.classes.backBtnContainer, props.classes.rightBorder].join(' ')
          : props.classes.backBtnContainer
      }>
      {!(props.currentStep === 'monoHotelAvail' && props.webType === 'WI') && (
        <div className={props.classes.backButton}>
          <Button onClick={props.goBackClick()} ariaLabel={'back'}>
            <RichText
              defaultStyle={false}
              icon={
                props.langCode !== 'AR'
                  ? {
                    content: '\\',
                    innerStyle: ['mainColor', 'fontSize10']
                  }
                  : {
                    unicodeContent: 'e000',
                    innerStyle: ['mainColor', 'fontSize10']
                  }
              }
            />
          </Button>
        </div>
      )}
      {props.successAvail && (
        <div className={props.classes.selectRoom}>
          <RichText ucFirst={true} text={props.text} translate={true} />
          <BackBtnSegments
            totalSegments={props.totalSegments}
            activeSegment={(props.activeSegment || 0) + 1}
            currentStep={props.currentStep}
          />
        </div>
      )}
    </div>
  );
};

const OrderByFilter = props => (
  <SearchOptionOrderBy
    toggleSelected={props.toggleSelected}
    innerStyle={props.showOrderBy ? ['defaultStyle', 'selected'] : ['defaultStyle']}
  />
);

const FiltersBtn = props => (
  <Button
    onClick={props.toggleSelected}
    innerStyle={
      props.showFilters ? [props.classes.searchOptionsButton, 'selected'] : [props.classes.searchOptionsButton]
    }
    richText={{
      translate: true,
      plural: true,
      text: '_%filtro%_',
      innerStyle: ['capitalize', props.classes.searchOptionsButtonText],
      icon: {
        svg: 'filter',
        innerStyle: [props.classes.svgIcon]
      },
      rightIcon: {
        content: '',
        innerStyle: [props.classes.searchOptionsButtonIconOpen]
      }
    }}
  />
);

const FiltersFilter = props => (
  <SearchOptionFilter
    toggleSelected={props.toggleSelected}
    innerStyle={props.showFilters ? ['defaultStyle', 'selected'] : ['defaultStyle']}
    showFilters={props.showFilters}
  />
);

const CurrenciesBtn = props => (
  <Button
    onClick={props.toggleSelected}
    innerStyle={
      props.showCurrencies ? [props.classes.searchOptionsButton, 'selected'] : [props.classes.searchOptionsButton]
    }
    rightIcon={{
      content: '',
      innerStyle: [props.classes.searchOptionsButtonIconOpen]
    }}
    richText={{
      text: props.currentCurrencyCode,
      innerStyle: [props.classes.searchOptionsButtonText, 'mainColor']
    }}
  />
);

const CurrenciesFilter = props => (
  <SearchOptionCurrency
    toggleSelected={props.toggleSelected}
    innerStyle={props.showCurrencies ? ['defaultStyle', 'selected', props.type] : ['defaultStyle', props.type]}
    hotelCurrencyCode={props.hotelCurrencyCode}
    type={props.type}
  />
);

const SearchOptions = class SearchOptions extends React.Component {
  static displayName = 'SearchOptions';

  constructor(props) {
    super(props);
    this.state = {
      showCurrencies: false,
      showOrderBy: false,
      showFilters: false
    };
    this.closeTooltipByFamily = this.props.config.closeByFamily;
    this.toggleSelected = this.toggleSelected.bind(this);
    this.goBackClick = this.goBackClick.bind(this);
    this.goBack = this.props.config.goBack.bind(this);
  }

  goBackClick = (forceCity = false) => e => {
    e.preventDefault();
    const { config } = this.props;
    let hotelsCity;
    let hotelsCountry;
    let cityId = false;
    let countryId = false;
    if (config.stepType === 'mono') {
      if (config.city.size > 0 || forceCity) {
        cityId = forceCity ? forceCity : this.props.config.city.get('id');
        hotelsCity = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('city_id') === cityId)
          .toJS()
          .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());
      } else if (config.country.size > 0) {
        countryId = this.props.config.country.get('id');
        hotelsCountry = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('country_id') === countryId)
          .toJS()
          .reduce((hotelsCountry, hotel) => hotelsCountry.concat([hotel.id]), List());
      } else {
        cityId = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .find(h => h.get('id') === config.hotelId)
          .get('city_id');

        hotelsCity = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('city_id') === cityId)
          .toJS()
          .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());
      }
    }
    this.props.config.goBack(hotelsCity || hotelsCountry, cityId, countryId, config);
  };

  toggleSelected = (activeFilter,close) => e => {
    e && e.preventDefault();
    this.closeTooltipByFamily();
    const showCurrencies = activeFilter === 'currencies' && !this.state.showCurrencies,
      showOrderBy = activeFilter === 'order_by' && !this.state.showOrderBy,
      showFilters = activeFilter === 'filters' && !this.state.showFilters,
      newState = {
        showCurrencies: showCurrencies,
        showOrderBy: showOrderBy,
        showFilters: showFilters
      };
    this.setState(newState);
  };

  render() {
    const { config, theme } = this.props,
      { 
        hotels, 
        hotelId,
        city,
        country,
        roomsAvail,
        hotelsFilter,
        availableHotels,
        cities,
        destinationHasAvailability
      } = config;
    const { classes } = theme.styles;

    const availSuccess = roomsAvail.get('success') !== false;

    let urlHotel;
    let backBtnText = '';
    
    const hotelCity = cities.find(city => city.get('id') === hotels.getIn([hotelId, 'city_id']));

    switch (config.currentStep) {
      case 'customerForm':
        backBtnText = '_%introducir datos%_';
        break;
      case 'serviceHotelAvail':
        backBtnText = '_%selecciona extras%_';
        break;
      default:
        if (availSuccess) {
          backBtnText = '_%selecciona habitación%_';
        }
        break;
    }

    if (hotelId) {
      urlHotel = hotels.getIn([hotelId, 'slug']) || hotels.getIn([hotelId, 'website'], '');   
    }

    let destinationName = '',
      hotelCurrencyCode = '';

    if (config.stepType === 'mono') {
      hotelCurrencyCode = config.hotels.getIn([hotelId, 'currency', 'code']);
    }

    if (city.size > 0) {
      destinationName = city.get('name');
    } else {
      destinationName = country.get('name');
    }

    let body;
    if (config.stepType === 'multi') {
      body = (
        <div
          className={
            config.availableHotels.size > 1
              ? classes.relativeFilter
              : [classes.monoFilter, classes.relativeFilter].join(' ')
          }>
          <span className={[classes.multiHotelSearchOptionsHeader].join(" ")}>
            <strong>
              {hotelsFilter.size ? availableHotels.toList().filter(hotelId => hotelsFilter.has(hotelId)).size : availableHotels.size}{' '}
              <RichText translate={true} quantity={config.availableHotels} plural={config.availableHotels.size}>
                _%hotel%_
              </RichText>
            </strong>{' '}
            <RichText translate={true} quantity={config.availableHotels} plural={config.availableHotels.size}>
              _%disponible%_
            </RichText>{' '}
            <RichText translate={true}>_%en%_</RichText> <strong>{destinationName}</strong>{' '}
            <RichText translate={true}>_%para sus fechas%_</RichText>
          </span>
          <div className={classes.searchOptionsContainer}>
            {config.availableHotels.size > 1 && (
              <React.Fragment>
                <div className={[classes.filterContainer, classes.relativeContainer].join(' ')}>
                  <OrderByBtn
                    toggleSelected={this.toggleSelected('order_by')}
                    showOrderBy={this.state.showOrderBy}
                    currentOrderBy={config.orderBy}
                    classes={classes}
                  />
                  {this.state.showOrderBy && (
                      <OrderByFilter
                      toggleSelected={this.toggleSelected}
                      showOrderBy={this.state.showOrderBy}
                      classes={classes}
                    />
                  )}
                </div>
                <div className={classes.filterContainer}>
                  <FiltersBtn
                    toggleSelected={this.toggleSelected('filters')}
                    showFilters={this.state.showFilters}
                    classes={classes}
                  />
                  {this.state.showFilters && (
                      <FiltersFilter
                        toggleSelected={this.toggleSelected}
                        showFilters={this.state.showFilters}
                        classes={classes}
                      />
                  )}
                </div>
              </React.Fragment>
            )}
            <div className={classes.filterContainer}>
              <CurrenciesBtn
                toggleSelected={this.toggleSelected('currencies')}
                showCurrencies={this.state.showCurrencies}
                currentCurrencyCode={config.currentCurrencyCode}
                classes={classes}
              />
              {this.state.showCurrencies && (
                <CurrenciesFilter
                  toggleSelected={this.toggleSelected}
                  showCurrencies={this.state.showCurrencies}
                  hotelCurrencyCode={hotelCurrencyCode}
                  type={config.stepType}
                  classes={classes}
                />
              )}
            </div>
          </div>
        </div>
      );
    } else {
      body = (
        <div className={classes.monoHotelSearchOptionsContent}>
          <BackBtn
            goBackClick={this.goBackClick}
            text={backBtnText}
            currentStep={config.currentStep}
            totalSegments={config.totalSegments}
            activeSegment={config.activeSegment}
            successAvail={availSuccess}
            webType={config.webType}
            classes={classes}
            langCode={config.langCode}
          />
          {config.currentStep === 'monoHotelAvail' && this.props.theme.deviceType === 'DESK' && availSuccess && <ButtonCalendar />}
          {config.currentStep === 'monoHotelAvail' && config.webType !== 'WI' && (
            <>
              {destinationHasAvailability && <div className={
                availSuccess
                  ? classes.hotelsLink
                  : [classes.hotelsLink, classes.borderRight].join(' ')
              }>
                <DestinationAvailBtn 
                  id={'td-d1-destination-subh-00'}  
                  hotelCity={hotelCity} 
                  goBack={this.goBackClick(hotelCity.get('id', false))} 
                  deviceType={this.props.theme.deviceType}
                />
              </div>}
              <div
                className={
                  availSuccess
                    ? classes.hotelLink
                    : [classes.hotelLink, classes.borderRight].join(' ')
                }>
                <HotelInfoButton langCode={config.langCode} urlHotel={urlHotel} deviceType={this.props.theme.deviceType} />
              </div>
            </>
          )}
          {contains(config.currentStep, ['monoHotelAvail', 'serviceHotelAvail']) &&
            availSuccess && (
              <React.Fragment>
                <div className={classes.currenciesButton}>
                  <CurrenciesBtn
                    toggleSelected={this.toggleSelected('currencies')}
                    showCurrencies={this.state.showCurrencies}
                    currentCurrencyCode={config.currentCurrencyCode}
                    classes={classes}
                  />
                </div>
                {this.state.showCurrencies && (
                  <CurrenciesFilter
                    toggleSelected={this.toggleSelected}
                    showCurrencies={this.state.showCurrencies}
                    hotelCurrencyCode={hotelCurrencyCode}
                    type={config.stepType}
                    classes={classes}
                  />
                )}
              </React.Fragment>
            )}
        </div>
      );
    }

    return <div className={theme.computedInnerStyle}>{body}</div>;
  }
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: (totalSegments, availServices, reservationBlocks, group) => (hotelsIds, cityId, countryId, config) => {
      const currentStep = config.currentStep;
      if (currentStep === 'monoHotelAvail') {
        dispatch(currentHotelActions.clear());
        if (cityId) {
          dispatch(paramsActions.updateParams(Map({ hotelId: null, hotels: hotelsIds, city_id: cityId })));
        } else if (countryId) {
          dispatch(paramsActions.updateParams(Map({ hotelId: null, hotels: hotelsIds, country_id: countryId })));
        }
        dispatch(currentHotelsActions.set(hotelsIds));
        dispatch(stepActions.prev());
        dispatch(actions.router.update());
        dispatch(availServicesActions.getAsync());
        
        return Promise.all([
          dispatch(hotelsActions.getAsync()),
          dispatch(loyaltyActions.getDescriptiveAsync(group)).then(()=> dispatch(availActions.getAvailAsync(group,'loyalty')))
        ]).then(() => {
          dispatch(orderByActions.set(group === 'eurostarshotels' ? 'proximity' : 'price'));
          dispatch(filterActions.get());
        })
          .tap(dispatch(eventsActions.trigger('show_avail')));
      } else {
        if (
          currentStep === 'customerForm' &&
          !filterAvailServices(availServices.get('services'), reservationBlocks).size
        ) {
          dispatch(stepActions.change('monoHotelAvail'));
        } else {
          dispatch(stepActions.prev());
        }
        dispatch(actions.router.update());
      }
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const params = store.getIn(['customer', 'params', 'params'], undefined);
  const webType = store.getIn(['customer', 'web_type'], false);

  const country =
    webType !== 'WI' &&
    params &&
    params.get('country_id') &&
    store.getIn(['hotels', 'hotels_info', 'countries']).find(country => {
      return country.get('id') === parseInt(params.get('country_id'), 10);
    });

  const city =
    webType !== 'WI' &&
    params &&
    params.get('city_id') &&
    store.getIn(['hotels', 'hotels_info', 'cities']).find(city => {
      return city.get('id') === parseInt(params.get('city_id'), 10);
    });

  const totalSegments = hotelId
    ? store.getIn(['hotels', hotelId, 'params', 'query_params', 'occups']).keySeq().size
    : 1;

  const currentStep = store.getIn(['customer', 'step', 'current_step', 'code'], null);
  let availableHotels = ownProps.availableHotels || null;
  if (currentStep === 'multiHotelAvail' && !availableHotels) {
    const hotelsAvail = reduceWhileResolved(store, 'avail');
    availableHotels =
      hotelsAvail &&
      hotelsAvail
        .filter((hotelAvail, hotelId) =>
          checkAvailSegments(
            store.getIn([
              'avail',
              hotelId,
              store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "multi", "string_params"])]),
              'raw_response'
            ])
          )
        )
        .keySeq()
        .map(key => key);
  }

  const roomsAvail = store.getIn(
    ['avail', hotelId, store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono", "string_params"])]), 'response'],
    Map()
  );
  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  const availServices =
    currentStep === 'customerForm' &&
    store.getIn([
      'availServices',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']),
      'response'
    ]);

  const activeSegment = reservationBlocks
    ? reservationBlocks.reduce((activeSegment, block) => {
      if (block.get('room_id', false)) {
        activeSegment++;
      }
      return activeSegment;
    }, 0)
    : 1;

  const hotelGroup = store.getIn(['hotels', hotelId, 'group']);

  const availCacheQueryParams = store.getIn(['customer', 'params', 'avail_cache_query_params'], Map());

  const availCache = store.getIn(['availCache', hotelGroup, availCacheQueryParams], false);

  const startDate = store.getIn(['customer', 'params', 'url_params', 'start'], false);
  const endDate = store.getIn(['customer', 'params', 'url_params', 'end'], false);

  const getDateRange = (start, end) => {
    const range = [];
    let currentDate = moment(start);
    const finalDate = moment(end);
  
    while (currentDate.isSameOrBefore(finalDate, 'day')) {
      range.push(currentDate.format('YYYY-MM-DD'));
      currentDate.add(1, 'day');
    }
  
    return range;
  };

  const dateRange = getDateRange(startDate, endDate);

  let destinationHasAvailability = false;

  if (availCache) {
    destinationHasAvailability = true;
    dateRange.forEach((date) => {
      if (availCache.getIn([date, 'count'], 0) < 2) {
        destinationHasAvailability = false;
        return;
      }
    });
  }


  return {
    reservationBlocks: currentStep === 'customerForm' && reservationBlocks,
    availServices: availServices,
    availableHotels: availableHotels,
    currentStep: currentStep,
    stepType: store.getIn(['customer', 'step', 'current_step', 'type'], null),
    hotelsIds: store.getIn(['customer', 'current_hotels']),
    hotelId: hotelId,
    hotels: store.getIn(['hotels']),
    avail: store.getIn(['avail']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    cities: store.getIn(['hotels', 'hotels_info', 'cities'], List()),
    totalSegments: totalSegments,
    activeSegment: activeSegment >= totalSegments ? totalSegments - 1 : activeSegment,
    orderBy: store.getIn(['customer', 'order_by', 'type']),
    city: city || Map(),
    country: country || Map(),
    roomsAvail: roomsAvail,
    hotelsFilter: store.getIn(['customer', 'filters', 'hotels']) || Set(),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    webType: webType,
    group: store.get("group", false),
    destinationHasAvailability: destinationHasAvailability
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    goBack: dispatchProps.goBack(stateProps.totalSegments, stateProps.availServices, stateProps.reservationBlocks, stateProps.group)
  });
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  showPopover,
  PropertyManager([
    'theme',
    'hotelsIds',
    'hotels',
    'availableHotels',
    'avail',
    'availServices',
    'currentCurrencyCode',
    'cities',
    'hotelId',
    'goBack',
    'totalSegments',
    'activeSegment',
    'orderBy',
    'currentStep',
    'stepType',
    'city',
    'country',
    'roomsAvail',
    'closeByFamily',
    'langCode',
    'webType',
    'hotelsFilter',
    'destinationHasAvailability'
  ]),
  withThemeJSS({ styleFile, link: true })
)(SearchOptions);
